var render = function render(){
  var _vm$design$r, _vm$design$r2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    staticClass: "float-left mr-3 mb-1",
    staticStyle: {
      "width": "30%",
      "max-width": "132px"
    },
    attrs: {
      "tile": ""
    }
  }, [_c('catalog-preview', {
    attrs: {
      "design": {
        name: _vm.design.name,
        type: (_vm$design$r = _vm.design.r) === null || _vm$design$r === void 0 ? void 0 : _vm$design$r.content_type,
        key: (_vm$design$r2 = _vm.design.r) === null || _vm$design$r2 === void 0 ? void 0 : _vm$design$r2.key,
        id: _vm.designId
      }
    }
  })], 1), _c('div', {
    staticClass: "text--label-active grey--text"
  }, [_vm._v("Card design name")]), _c('h1', {
    staticClass: "overline short"
  }, [_vm._v(_vm._s(_vm.design.name))]), _c('div', {
    staticClass: "mt-6 text--label-active grey--text"
  }, [_vm._v("Card designed by")]), _c('h2', {
    staticClass: "overline short"
  }, [_vm.design.username == 'Ellacard staff' ? [_vm._v("Ellacard staff")] : _vm.design.username ? _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog',
        query: {
          q: '#' + _vm.design.username
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.design.username) + " ")]) : [_vm._v("Anonymous")]], 2), _c('div', {
    staticClass: "pt-6",
    style: {
      clear: _vm.$vuetify.breakpoint.xsOnly ? 'both' : null
    }
  }, [_c('div', {
    staticClass: "text--label-active grey--text mb-2"
  }, [_vm._v("Share this card design")]), _c('social-share-btns', {
    staticStyle: {
      "max-width": "320px"
    },
    attrs: {
      "description": "Check out this card design on Ellacard",
      "title": 'Ellacard card design: ' + _vm.design.name,
      "url": 'https://ellacard.com/cards/' + _vm.designId
    }
  })], 1), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }